import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

const ModalFooterContainer = styled(ModalFooter)`
  border-top: none;
  padding-top: 0;
`;

const BoldText = styled.div`
  padding-top: 15px;
  padding-bottom: 10px;
`;

const ModalContainer = styled(Modal)`
  z-index: 999;
`;

const OfflineModal = () => {
  const { isOffline, productTypeSmall } = useSelector(
    state => ({
      isOffline: state.appStatus.isOffline,
      productTypeSmall: state.test.productTypeSmall,
    }),
    shallowEqual
  );

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(isOffline);
  }, [isOffline, setShowModal]);

  const onClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <ModalContainer isOpen={showModal} centered size="lg">
        <ModalBody>
          <div>Your internet connection is lost</div>
          <BoldText>
            <b>Please Note:</b>
          </BoldText>
          <ul>
            <li>
              The {productTypeSmall} time is being counted and the{' '}
              {productTypeSmall} will get submitted as per schedule.
            </li>
            <li>
              All unsaved/un-uploaded files will get discarded automatically.
            </li>
            <li>
              You can resume the {productTypeSmall} by using the unique link
              sent to your email id before it ends.
            </li>
          </ul>
        </ModalBody>
        <ModalFooterContainer>
          <Button color="primary" onClick={onClose}>
            Okay
          </Button>
        </ModalFooterContainer>
      </ModalContainer>
    </>
  );
};

export default OfflineModal;
